import React, { memo, useMemo } from 'react';
import { AnchorLink } from 'components/anchorLink';
import { Icon, IconsEnum } from 'components/Icons';
import styles from './SectionTitle.module.scss';
import classNames from 'classnames';
import { isNotEmpty, isTruthy } from 'utility/functions';

export type SectionTitleProps = {
  title: string;
  url?: string;
  subtitle?: string;
  noPadding?: boolean;
  className?: string;
  isAlignCenter?: boolean;
};

export const SectionTitle: React.FC<SectionTitleProps> = memo(function SectionTitle({
  title,
  url,
  subtitle,
  noPadding,
  className,
  isAlignCenter,
}: SectionTitleProps) {
  const relativeUrl = useMemo(() => {
    const path = (url ?? '').split('/');
    if (isTruthy(path.length) && path[0] !== '') {
      path.unshift('');
    }
    return path.join('/');
  }, [url]);

  return (
    <div
      className={classNames(className ?? '', {
        [styles.alignCenter]: isAlignCenter,
        [styles.titleContainer]: !noPadding,
      })}
    >
      {isNotEmpty(relativeUrl) ? (
        <h3 className={styles.title}>
          <AnchorLink href={relativeUrl} className={styles.link}>
            {title}
            <Icon iconId={IconsEnum.ARROW} className={styles.titleIcon} color="var(--color-primary)" />
          </AnchorLink>
        </h3>
      ) : (
        <h3 className={styles.title}>{title}</h3>
      )}

      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
});
